import { objectToQueryString } from 'Utils/utils'
import AxiosClient from './api'
import END_POINT from './constants'

export function getDataDashboardMain() {
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.DASHBOARD_MAIN.GET_ALL}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function getDataTabByDate(payload) {
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.DASHBOARD_MAIN.GET_TAB_BY_DATE}/`, payload)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function getProportionSales() {
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.DASHBOARD_MAIN.GET_PROPORTION_SALES}`)
      .then((res) => {
        resolve(res.data.result)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function getSummary(payload) {
  const params = objectToQueryString(payload)
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.DASHBOARD_MAIN.GET_SUMMARY}${params}`)
      .then((res) => {
        resolve(res.data.result)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function getUserActivity(payload) {
  const { type, from, to } = payload
  const params = objectToQueryString({
    from, to
  })
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.DASHBOARD_MAIN.GET_USER_ACTIVITY}/${type}${params}`)
      .then((res) => {
        resolve(res.data.result)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function getSalesTrend(payload) {
  const { type, from, to } = payload
  const params = objectToQueryString({
    from, to
  })
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.DASHBOARD_MAIN.GET_SALES_TREND}/${type}${params}`)
      .then((res) => {
        resolve(res.data.result)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function getVisit(payload) {
  const { type, from, to } = payload
  const params = objectToQueryString({
    from, to
  })
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.DASHBOARD_MAIN.GET_VISIT}/${type}${params}`)
      .then((res) => {
        resolve(res.data.result)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function getTopSearch() {
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.DASHBOARD_MAIN.GET_TOP_SEARCH}`)
      .then((res) => {
        resolve(res.data.result)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}
